export default __webpack_public_path__ + "static/media/nearby_tile.98a4506d.png";